var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.33333C6 2.59695 6.59695 2 7.33333 2H12C12.7364 2 13.3333 2.59695 13.3333 3.33333V10C13.3333 10.7364 12.7364 11.3333 12 11.3333H10.6667V10H12V3.33333H7.33333V4H6V3.33333ZM4.62761 5.13228C4.88092 4.83675 5.25072 4.66667 5.63996 4.66667H8.66667C9.40305 4.66667 10 5.26362 10 6V12.6667C10 13.403 9.40305 14 8.66667 14H4C3.26362 14 2.66667 13.403 2.66667 12.6667V7.91328C2.66667 7.595 2.78052 7.28722 2.98766 7.04556L3.33333 7.34185L2.98766 7.04556L4.62761 5.13228ZM4 8.66667V12.6667H8.66667V6H6.66667V7.33333C6.66667 8.06971 6.06971 8.66667 5.33333 8.66667H4ZM5.33333 6.35773V7.33333H4.4971L5.33333 6.35773Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopy);
export default __webpack_public_path__ + "static/media/file-copy.5bddc9eaaf2fbb0963ed9fd524dcc443.svg";
export { ForwardRef as ReactComponent };